package com.milta.core.localization.translations.fr

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Scanner une étiquette",
    analysingTitle = "Lecture de l'étiquette…",
    analysingSubtitle = "Nous cherchons le nom, l'adresse et le téléphone du destinataire. Quelques secondes suffisent.",
    reviewTitle = "Confirmer la livraison",
    deliveryDetectedLabel = "Livraison détectée",
    allReadableLabel = "Tout lisible",
    fieldToCompleteSingularSuffix = "champ à compléter",
    fieldToCompletePluralSuffix = "champs à compléter",
    recipientNotDetectedValue = "Non détecté",
    addressNotDetectedValue = "Non détectée",
    phoneNotDetectedValue = "Non détecté",
    fieldRequiredWarning = "Champ requis pour ajouter la livraison",
    recipientCorrectionPlaceholder = "Saisir le destinataire…",
    addressCorrectionPlaceholder = "Saisir l'adresse…",
    unreadableTitle = "Étiquette illisible.",
    unreadableMessage = "Reprenez une photo cadrée sur l'étiquette, bien éclairée et sans reflet.",
    maxAttemptsMessage = "Complétez cette livraison manuellement, ou reprenez le scan avec une nouvelle photo.",
)
